export const USER_TOKEN_COOKIE = 'user-token';

export function getCookie(name: string): string | undefined {
  const value = '; ' + document.cookie;
  const parts = value.split('; ' + name + '=');
  return parts.length == 2
    ? parts
        .pop()!
        .split(';')
        .shift()
    : undefined;
}

export function getUserToken() {
  return getCookie(USER_TOKEN_COOKIE);
}
